import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	disabledProjectAccessMessage: {
		id: 'project-details.project-access.disabled-access-level.message',
		defaultMessage:
			'Anyone with access to {cloudName} can access and administer this project. Upgrade your plan to customize project permissions.',
		description:
			'The user is unable to modify the project access because their product tier (plan) does not support it. The suggestion to upgrade your plan is not a link.',
	},
	disabledProjectAccessMessageSiteAdmin: {
		id: 'project-details.project-access.disabled-access-level.message.siteadmin',
		defaultMessage:
			'Anyone with access to {cloudName} can access and administer this project. {callToAction} to customize project permissions.',
		description:
			'The user is unable to modify the project access because their product tier (plan) does not support it. The "callToAction" will be substituted with "Upgrade your plan"' +
			' and leads to a page where the admin can upgrade their product to support this.',
	},
	disabledProjectAccessMessageSiteAdminLink: {
		id: 'project-details.project-access.disabled-access-level.message.siteadmin.link',
		defaultMessage: 'Upgrade your plan',
		description:
			'Call to action that will appear in the sentence: "Upgrade your plan to customize project permissions". ' +
			'A plan is the edition or tier of the product that the admin is currently subscribed to.',
	},
});
